export default <const>{
  CHARTBIT_MAINTENANCE_WARNING: 'chartbit_maintenance_warning',
  CHARTBIT_MAINTENANCE_ON: 'chartbit_maintenance_on',
  CHARTBIT_DISABLE_AUTOSAVE: 'chartbit_disable_autosave',
  CHARTBIT_IFRAME_LOGGING: 'chartbit_iframe_logging',
  CHARTBIT_DEBUG: 'chartbit_debug',
};
